
<template>
  <div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <!--
    <div class="row margin-b-l">
      <div class="col-12">
        <emp-filter @applyFilter="getFilterData($event)" />
      </div>
    </div>-->

    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
        You have only view permission.
    </div>

    <div class="searchsort margin-b-m">
      <!-- <search-dropdown
        v-model="searchText"
        :employeeData="employeeData"
        @empselected="(emp)=>selectedEmp(emp)"
      />-->

      <!-- <search-dropdown
        v-model="searchText"
        :employeeData="employeeData"
        @empselected="(emp)=>selectedEmp(emp)"
        @getList="filterData($event)"
      />-->
      <tl-search class="search-width marginbot-20" @change="filterData" :disabled="!ifTeamleaderAnchorPermission"/>

      <!-- <div class="sorttext">
        <span>Sort By:</span>
      </div>&nbsp; &nbsp; &nbsp;
      <tl-select
        class="customwidth"
        :value="designation"
        :options="['Recently Joined', 'Admin', 'IT']"
        @change="(val)=>changeLegalEntity(val)"
      />-->
    </div>
    <data-table
      :columns="columnNames"
      :tableData="empList"
      :checkbox="false"
      :search="searchText"
      :showedit="false"
      :showinrow="false"
    >
      <template class="imgClass" v-slot:rowcontent="slotprops">
        <img
          v-if="slotprops.value.column.key=='image'"
          :src="slotprops.value.record[slotprops.value.column.key]"
        />
      </template>
    </data-table>

    <pop-up-message
      v-if="showSuccessMsg"
      :message="`${empName} has been successfully added.`"
      btnText="Back To Add Exit Employees"
      @back="backToAddExitEmployeesPage"
    ></pop-up-message>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";

export default {
  name: "AddExitEmployees",
  components: {
    SearchDropdown
  },
  // props: {
  //   empList: { type: Array, default: [] }
  // },
  data() {
    return {
      recentsearch: "All",
      recents: "",
      empCN: "abc123",
      empName: "",
      empId: "",
      exitreason: "Select",
      department: "",
      designation: "",
      location: "",
      costCenter: "",
      sort: "Recently Joined",
      search: "",
      showSuccessMsg: false,
      noofdays: "",
      selectedDates: "",
      departmentOptions: [],
      costCenterOptions: [],
      designationOptions: [],
      locationOptions: [],
      exitreasonOptions: [
        "Cessation",
        "Resigned",
        "Termination",
        "Death in service",
        "Permanent disability",
        "Retirement",
        "Superannuation"
      ],
      columnNames: [

        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Resignation Date",
          key: "initiation_date"
        },
        {
          label: "Last Working Date",
          key: "last_working_date"
        },
        {
          label: "Reason",
          key: "reason_for_exit"
        }
      ],
      searchText: "",
      employeeData: [],
      auto_suggestions: false,
      filterEmpData: [],
      showDataTable: false,
      exitsCount: 0,
      errmsg: "",
      toast: false,
      body: {
        le_id: this.le_id,
        cost_centers: [],
        bunits: [],
        locs: [],
        designations: []
      },
      formData: {
        payGroupObj: null,
        criteriaObj: null,
        valueObj: null
      },
      criteriaArray: [
        { name: "Location" },
        //{ name: "Salary Band" },
        //{ name: "Grade" },
        { name: "Cost Centre" },
        { name: "BUs" },
        { name: "Designations" }
      ],

      valueArray: [],
      payGroupsList: [],
      criteriaList: [],
      empList: [],
      valueList: [],
      subCriteriaLabel: "", // PL_2869
      exitEmployeeDetailsValue: false,
      role: ""
    };
  },
  activated() {
    this.le_id();
    this.fetchAllPayGroups();
    //this.fetchAllExitEmps();
    this.getFilterData();
    this.empList=[];
    this.getOrgLeIdList();
  },
  mounted() {
    this.getFilterData();
    this.empList=[];
    this.getOrgLeIdList();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ...mapState({
      employeesJoiningsData: state => state.payroll.joinings.joinings, //fetch all employees data
      business_units: state => state.onboard.business_units.data,
      salary_bands: state => state.onboard.salary_bands.data,
      locations: state => state.onboard.locations.data,
      salary_grades: state => state.onboard.salary_grades.data,
      cost_centres: state => state.onboard.cost_centres.data,
      designations: state => state.onboard.designations.entityWiseData
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.exitEmployeeDetailsValue) {
            return true;
          } else {
            return false;
          }
        } 
        // else {
        // return true 
        // }
    }
  },
  methods: {
    filterData(searchText) {
      this.searchText = searchText;
    },
    deleteData() {
      this.showDataTable = false;
    },
    backToAddExitEmployeesPage() {
      this.showSuccessMsg = false;
    },
    ...mapActions({
      act_fetchAll: "dashboard/payroll/utilities/addexitemployees/fetchExits",
      act_create: "dashboard/payroll/utilities/addexitemployees/create",
      act_fetchLegalEntityNonExitsEmployeeFilterList:
        "dashboard/payroll/utilities/addexitemployees/fetchLegalEntityNonExitsEmployeeFilterList",
      act_fetchAllEmployees: "globalapi/globalemployees/fetchAll",
      act_departmentList: "onboard/departments/fetchAll",
      act_locationList: "onboard/locations/fetchAll",
      act_fetchCostCenters: "onboard/cost_centres/fetchAll",
      act_designationList: "onboard/designations/fetchAll",
      act_fetchAll_PayGroups: "payroll/paygroups/fetchAll"
    }),
    /** To fetch the employees list from server */
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.le_id);

        if (res.data.status) {
          this.employeeData = res.data.payload;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },
    /** function to fetch the Paygroups of that LE */
    async fetchAllPayGroups() {
      try {
        let res = await this.act_fetchAll_PayGroups(this.le_id);
        if (res.status == 200 || res.status == 201) {
          let dataArr = res.data.payload.data;
          this.payGroupsList = dataArr;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async getFilterData() {

      this.body.le_id = this.le_id;

      try {
        let res = await this.act_fetchLegalEntityNonExitsEmployeeFilterList(
          this.body
        );
        if (res.data.payload) {
          let empData=[];
          res.data.payload.forEach(element => {
             if(element.EmployeeFnf.last_working_date.includes('T') || element.EmployeeFnf.initiation_date.includes('T'))
              {
                 element.EmployeeFnf.last_working_date = element.EmployeeFnf.last_working_date.split('T')[0]
                 element.EmployeeFnf.initiation_date=element.EmployeeFnf.initiation_date.split('T')[0]
              }else if(element.EmployeeFnf.last_working_date.includes(' ') || element.EmployeeFnf.initiation_date.includes(' ') )
              {
               element.EmployeeFnf.last_working_date = element.EmployeeFnf.last_working_date.split(' ')[0]
               element.EmployeeFnf.initiation_date=element.EmployeeFnf.initiation_date.split(' ')[0]
              }
            empData.push({
              id: element.id,
              name:
                element.first_name +
                " " +
                (element.last_name ? element.last_name : ""),
              code: element.code,
              initiation_date:element.EmployeeFnf.initiation_date,
              last_working_date:element.EmployeeFnf.last_working_date,
              reason_for_exit:element.EmployeeFnf.reason_for_exit,
            });
            //console.log(element.EmployeeFnf.last_working_date)
          });
          this.empList.push(...empData);
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On Criteria drop down changes */
    changeCriteria(event) {
      if (event) {
        this.valueArray = [];
        this.formData.criteriaObj = event;
        this.formData.valueObj = [];
        this.subCriteriaLabel = event.name; // PL_2869
        if (event.name == "Location") {
          this.valueArray = this.locations[this.le_id]
            ? this.locations[this.le_id]
            : [];
        } else if (event.name == "Salary Band") {
          this.valueArray = this.salary_bands[this.le_id]
            ? this.salary_bands[this.le_id]
            : [];
        } else if (event.name == "Grade") {
          this.valueArray = this.salary_grades[this.le_id]
            ? this.salary_grades[this.le_id]
            : [];
        } else if (event.name == "Cost Centre") {
          this.valueArray = this.cost_centres[this.le_id]
            ? this.cost_centres[this.le_id]
            : [];
        } else if (event.name == "BUs") {
          this.valueArray = this.business_units.data
            ? this.business_units.data
            : [];
        } else if (event.name == "Designations") {
          this.valueArray = this.designations[this.le_id]
            ? this.designations[this.le_id]
            : [];
        }
      }
    },
    /** On Sub-criteria dropdown selection */
    changeValue(event) {
      if (event) {
        this.body.locs = [];
        this.body.bands = [];
        this.body.bunits = [];
        this.body.cost_centers = [];
        this.body.designations = [];
        let valueArr = event;
        if (this.formData.criteriaObj.name == "Location") {
          valueArr.forEach(item => {
            this.body.locs.push(item.id);
          });
        } else if (this.formData.criteriaObj.name == "Salary Band") {
          valueArr.forEach(item => {
            this.body.bands.push(item.id);
          });
        } else if (this.formData.criteriaObj.name == "Cost Center") {
          valueArr.forEach(item => {
            this.body.cost_centers.push(item.id);
          });
        } else if (this.formData.criteriaObj.name == "BUs") {
          valueArr.forEach(item => {
            this.body.bunits.push(item.id);
          });
        } else if (this.formData.criteriaObj.name == "Designations") {
          valueArr.forEach(item => {
            this.body.designations.push(item.id);
          });
        }
      }
    },
    /** On paygroups drop down selection */
    payGroupChanged(event) {
      if (event){
        this.body.paygroups = [event.id];
      }else{
          this.body.paygroups = [];
      }
    },

    filterList() {
      this.getFilterData();
    },

    changeDepartment(val) {
      this.department = val;
    },
    changeDesignation(val) {
      this.designation = val;
    },
    changeCostCenter(val) {
      this.costCenter = val;
    },
    changeLocation(val) {
      this.location = val;
    },
    /** To clear the form data */
    refresh() {
      this.empCN = "";
      this.resignDate = "";
      this.lwd = "";
      this.reason = "";
      this.remarks = "";
      this.esiRemarks = "";
      this.processType = "";
    },
    changeExitReason(val) {
    },
    /** Function to submit the form data to server */
    async performAction() {
      let reason = "";
      if (this.reason == "Cessation") {
        reason = "fired";
      }
      if (this.reason == "Resigned") {
        reason = "resigned";
      }
      let obj = {
        data: [
          {
            le_id: this.le_id,
            employee_id: this.empId,
            initiation_date: this.resignDate,
            last_working_date: this.lwd,
            reason_for_exit: reason,
            remarks: null
          }
        ]
      };
      this.$root._data.isSaving = true;
      let res = await this.act_create(obj);
      setTimeout(() => {
        if (res.status == 200 || res.status == 201) {
          this.showSuccessMsg = true;
        }
        this.$root._data.isSaving = false;
        this.refresh();
      }, 500);
    },
    /** Search logic */
    searchData(key, array) {
      const final = [];
      for (let i = 0; i < array.length; i++) {
        let searchObj = array[i].name;
        if (
          searchObj != null &&
          searchObj.toLowerCase().search(key.toLowerCase()) !== -1
        ) {
          final.push(array[i]);
        }
      }
      return final;
    },
    addEmployee() {
      this.showDataTable = true;
      this.performAction();
    },
    /** On employee card selection */
    selectedEmp(emp) {
      this.empName = emp.name;
      this.empId = emp.code;
    },

    ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
        const org = this.orgId;
        const le = this.le_id;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.exitEmployeeDetailsValue = data.data.user.permissions.exit_employee_details ? true : false;
        //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
.paygrpsDiv {
  display: flex;
  cursor: pointer;
  grid-template-columns: repeat(4/2fr);
  grid-template-rows: auto;
  grid-gap: 2px;
  margin-top: 35px;
  margin-bottom: 35px;
  span {
    color: #646464;
    font-size: 16px;
  }
}
.paygrps-info {
  color: #646464;
  cursor: pointer;
  text-align: center;
  b {
    font-size: 24px;
  }
}
.alignPaygrp {
  margin-right: 50px;
  margin-left: 13px;
}
.text-area {
  width: 759px;
  height: 85px;
  border-radius: 4px;
  border: solid 1px #c6c9c8;
  background-color: #ffffff;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}
.content {
  margin-left: 20px;
  margin-top: 15px;
}
.subtitle {
  width: 316px;
  height: 15px;
  font-family: Montserrat;
  font-size: 12px;
  color: #646464;
}
.main-header {
  color: #6d6d6d;
  margin-top: 25px;
  font-size: 16px;
}
.uploadMethoRadio {
  display: flex;
  margin-bottom: 2%;
}
.line {
  border-bottom: 1px solid #c8c8c8;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 10px;
}
.bottom-line {
  border-bottom: 1px solid #34c0be;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 15%;
}
select .dropdown {
  border-radius: 4px;
  border: 1px solid #dadada;
  padding: 10px;
  transition: ease-in-out, width 0.35s ease-in-out;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}
.width-search {
  width: 427px;
  height: 35px;
}
.selectdiv {
  select {
    width: 100%;
    border-radius: 4px;
    outline: 0;
    font-size: 14px;
    color: #9f9da2;
    border: 1px solid #dadada;
    padding: 0 10px;

    &.errorr {
      border: 1px solid #e01717;
    }
    &.errorMessage {
      color: #e01717;
    }
  }
  span {
    font-size: 12px;
    margin-left: 3px;
    color: #9f9da2;
  }
}
.recent {
  align-self: self-end;
}
.extra-filters {
  display: flex;
  //   grid-gap: 10px;
  //   grid-template-columns: 0.29fr 0.2fr 0.2fr;
  //   margin-bottom: 2%;
  //   margin-top: 1%;
}
.custom-width {
  width: 206px;
  height: 35px;
  margin-right: 1.4%;
}

.remarks {
  margin-bottom: 2%;
}
.remarks-label {
  font-size: 12px;
  color: #c6c9c8;
}
.filterbtn {
  width: 97px;
  height: 35px;
  margin-top: 19.9%;
  margin-left: 130%;
  border-radius: 4px;
  border: solid 1px #34c0be;
  color: #34c0be;
  grid-column: -1/ -2;
  align-self: self-end;
  padding: 10px;
  margin-bottom: 3px;

  .more-filters {
    width: 74px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    color: #34c0be;
  }
}
.inputbox {
  width: 100px;
  height: 35px;
  padding: 4px;
  border: 1px solid #c6c9c8;
  border-radius: 4px;
  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}
.searchclass {
  width: 30%;
}
.btnGrpClass {
  float: right;
}
.imgClass {
  width: 70px;
  height: 70px;
}
.uploadDiv {
  width: 10%;
  margin-left: auto;
  text-align: center;
  justify-content: end;
  padding: 4px 0px 0px 0px;
  button {
    cursor: pointer;
    width: 60%;
    height: 70%;
    border-radius: 4px;
    color: #5d409f;
    border: 1px solid #5d409f;
  }
  img {
    height: 70%;
    margin-bottom: -6px;
  }
}
.img-part {
  img {
    width: 100%;
  }
}
.lop-report {
  .selectdiv {
    width: 50%;
    // margin-bottom: 1%;
    select {
      width: 50%;
      border-radius: 4px;
      outline: 0;
      font-size: 14px;
      color: #9f9da2;
      border: 1px solid #dadada;
      padding: 0 10px;

      &.errorr {
        border: 1px solid #e01717;
      }
      &.errorMessage {
        color: #e01717;
      }
    }
    span {
      font-size: 12px;
      margin-left: 3px;
      color: #9f9da2;
    }
  }
}
.export-emp {
  float: right;
  margin-bottom: 1%;
}
.export-section {
  margin-left: 6%;
  margin-top: 5px;
  align-items: center;
  display: flex;
}
.searchsort {
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: 10px;
  .sorttext {
    text-align: center;
    line-height: 30px;
    color: #726f75;
    padding: 0px 0px 0px 10px;
    margin-left: auto;
  }
}
.customwidth {
  width: 206px;
}
.sorticons {
  width: 13%;
  padding: 8px 0px 5px 10px;
  span {
    padding-top: 10px;
    padding-left: 10px;
    border-left: 2px solid #34c0be;
  }
}
.selected-employees-list {
  display: flex;
  margin-top: 5%;
  margin-bottom: 5%;
}
.download-btn {
  margin-top: 2%;
}
.upload {
  display: flex;
  width: 30%;
  margin-top: 2%;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(
      to right,
      lightgray 10px,
      rgba(255, 255, 255, 0) 0%
    ),
    linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(to right, lightgray 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%);
  background-position: top, right, bottom, left;
  background-repeat: repeat-x, repeat-y;
  background-size: 20px 1px, 1px 20px;
  height: 140px;
}
.label {
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 8px;
  color: #6e6e6e;
}
.upload-button {
  display: flex;
  align-items: center;
  label {
    cursor: pointer;
    border: 1px solid #5d409f;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 15px;
    color: #5d409f;
  }
  #upload-photo {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }
  img {
    height: 19px;
    width: 19px;
    margin-right: 8px;
  }
}

.customColumnGrid {
  display: grid;
  grid-template-columns: 15% 15% 15% 15%;
  grid-row-gap: 15px;
  grid-column-gap: 20px;
}

.btn-filter {
  margin-top: 15px;
  padding: 0px;
  min-height: 30px;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
